import {View} from 'MWC';
import tpl from '../../templates/desktop/main';
import {list} from '../../list';

export default class extends View {
    constructor(props) {
        super(props);
        this.state = {
            subMenuAbout: list.subMenuAbout,
            subMenuCards: list.subMenuCards,
            subMenuCredit: list.subMenuCredit,
            subMenuBusiness: list.subMenuBusiness,
            subMenuServices: list.subMenuServices,
            subMenuDeposits: list.subMenuDeposits,

            subMenuCards2: list.subMenuCards2,
            subMenuCredit2: list.subMenuCredit2,
            subMenuDeposits2: list.subMenuDeposits2,
            subMenuBusiness2: list.subMenuBusiness2,
            subMenuServices2: list.subMenuServices2,
            subMenuServices3: list.subMenuServices3,
            subMenuBusiness3: list.subMenuBusiness3,
            cards: false,
            deposits: false,
            credit: false,
            business: false,
            services: false,
            isCollapsed: false
        };

        this.toggleHover = this.toggleHover.bind(this);
        return this;
    }
    template = tpl;

    handleScroll = () => {
        const scrollY = window.scrollY;
        const halfViewport = window.innerHeight / 2;
        const elementHeight = 80;

        const adjustedScrollY = this.state.isCollapsed ? scrollY + elementHeight : scrollY;

        this.setState({isCollapsed: adjustedScrollY >= halfViewport});
    };

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    toggleHover(hover, name) {
        this.setState({[name]: hover});
    }

    static displayName = 'Header.Views.DesktopMain';
}
